module.exports = __webpack_public_path__ + "img/header_platform--transparent.7df09aaa.png";